<div
  (click)="goToTasks()"
  [pTooltip]="tooltip()"
  tooltipPosition="bottom"
  class="relative rounded-full p-1 text-gray-500 hover:text-gray-700 hover:cursor-pointer"
>
  <i class="pi pi-check-square !text-xl"></i>
  @if (pendingCount() > 0) {
    <span class="absolute top-1 right-1 w-2 h-2 rounded-full bg-[#C2620E] ring-2 ring-white"></span>
  }
</div>
